import { Dispatch, FC, SetStateAction, useEffect } from 'react';
import { PageInfo } from '../../models/PageInfo';
import { PageControlAssignments } from './TeacherAssignments';
import { useLazyLoadQuery } from 'react-relay';
import {
  AssignmentGetAssignmentsQuery,
  AssignmentsFilterInput,
} from '../../graphQLOperations/__generated__/AssignmentGetAssignmentsQuery.graphql';
import { getAssignments } from '../../graphQLOperations/Assignment';
import { AssignmentItemList } from '../../models/Assignment';

interface Props {
  setAssignments: Dispatch<SetStateAction<AssignmentItemList[]>>;
  pageControl: PageControlAssignments;
  fetchingData: boolean;
  firstLoad: boolean;
  pageInfo: PageInfo | undefined;
  setFetchingData: (state: boolean) => void;
  setFirstLoad: (state: boolean) => void;
  setPageInfo: (state: PageInfo) => void;
  setTotalRecords: (state: number) => void;
  filters: AssignmentsFilterInput;
}

export const AssignmentsQueryComponent: FC<Props> = ({
  fetchingData,
  firstLoad,
  pageInfo,
  setFetchingData,
  setFirstLoad,
  setPageInfo,
  setTotalRecords,
  pageControl,
  setAssignments,
  filters,
}) => {
  const isMovingNext = pageControl.page! - pageControl.prevPage === 1;
  const isMovingPrevious = pageControl.page! - pageControl.prevPage === -1;
  const isNotMoving = pageControl.page! - pageControl.prevPage === 0;

  const { assignments } = useLazyLoadQuery<AssignmentGetAssignmentsQuery>(
    getAssignments,
    {
      order: [{ dueOn: pageControl.sortOrder === 1 ? 'DESC' : 'ASC' }],
      filter: filters,
      first: fetchingData && (isMovingNext || isNotMoving || !pageInfo?.hasPreviousPage) ? pageControl.rows : null,
      last: fetchingData && isMovingPrevious && pageInfo?.hasPreviousPage ? pageControl.rows : null,
      skip: !firstLoad && !fetchingData,
      after: fetchingData && isMovingNext && pageInfo?.hasNextPage ? pageInfo?.endCursor : undefined,
      before: fetchingData && isMovingPrevious && pageInfo?.hasPreviousPage ? pageInfo?.startCursor : undefined,
    },
    { fetchPolicy: 'network-only', fetchKey: JSON.stringify({ pageControl, filters }) },
  );
  useEffect(() => {
    if (assignments?.nodes) {
      setTotalRecords(assignments.totalCount ?? 0);
      setPageInfo(assignments.pageInfo);

      setAssignments(assignments.nodes as unknown as AssignmentItemList[]);
    }
    setFetchingData(false);
    setFirstLoad(false);
  }, [assignments]);

  return <div style={{ display: 'none' }}></div>;
};
